import { watch, onBeforeUnmount, onMounted } from 'vue'
import { throttle } from 'lodash'
import screenfull from './screen-full'
import type { Ref } from 'vue'

export const useFullscreen = (
  targetRef: Ref<HTMLElement | undefined>,
  watchKey: Ref<boolean>,
  emit?
) => {
  const throttledFullscreenHander = throttle(() => {
    watchKey.value = screenfull.isFullscreen
    emit('fullscreen', screenfull.isFullscreen)
  }, 300)

  watch(
    () => watchKey.value,
    (val) => {
      if (!targetRef.value) return

      if (val) {
        // 全屏显示
        if (screenfull.isEnabled && !screenfull.isFullscreen) {
          screenfull.request(targetRef.value)
        }
      } else {
        // 退出全屏
        screenfull.exit()
      }
    }
  )

  onMounted(() => {
    screenfull.on('change', throttledFullscreenHander)
  })

  onBeforeUnmount(() => {
    screenfull.off('change', throttledFullscreenHander)
  })
}
